<template>
  <span class="validation-error"><slot></slot></span>
</template>
